import { Spin } from 'antd'

const Loader = () => <Spin className='Spinner' tip={<p className='font-bold text-[16px] !text-[#6941C6] mt-2'>Loading...</p>} size='large' />

export default Loader
